import i18n from "@/i18n";
import { api } from "@/lib/api";

const LANGS = ["en", "ml", "hi"];

// Convert a flat map of dotted keys ({"home.title_a": "..."}) into a nested
// object ({home: {title_a: "..."}}) so it can be deep-merged into i18n resources.
function unflatten(flat) {
  const out = {};
  for (const [key, value] of Object.entries(flat)) {
    const parts = key.split(".");
    let node = out;
    parts.forEach((p, i) => {
      if (i === parts.length - 1) node[p] = value;
      else node = node[p] = node[p] || {};
    });
  }
  return out;
}

// Merge admin overrides ({key: {en, ml, hi}}) on top of the bundled locales.
export function applyOverrides(data) {
  const perLang = { en: {}, ml: {}, hi: {} };
  for (const [key, vals] of Object.entries(data || {})) {
    for (const lng of LANGS) {
      const v = vals?.[lng];
      if (v != null && v !== "") perLang[lng][key] = v;
    }
  }
  for (const lng of LANGS) {
    if (Object.keys(perLang[lng]).length) {
      i18n.addResourceBundle(lng, "translation", unflatten(perLang[lng]), true, true);
    }
  }
  // Notify react-i18next consumers so they re-render with the merged text.
  i18n.changeLanguage(i18n.language);
}

// Fetch overrides from the backend and merge them. Never throws — the site
// falls back to bundled defaults if the request fails.
export async function loadSiteContent() {
  try {
    const { data } = await api.get("/site-content");
    applyOverrides(data);
  } catch {
    /* use bundled defaults */
  }
}
